var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detailproject__container"},[_c('BannerProjectDetail',{attrs:{"data":_vm.project}}),_c('ContentProjectDetail',{attrs:{"data":_vm.project}}),_c('ListOrtherProject',{attrs:{"data":_vm.item_filter.slice(0, 12)}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }